import { useStore } from 'react-redux'
import { Actions as FlashMessageActions } from 'actions/shared/flashMessage'

export const useFlashMessage = (): Record<string, any> => {
  const store = useStore()
  // Error
  const showErrorMessage = (message: string): void => {
    store.dispatch(
      FlashMessageActions.ADD({
        messages: [message],
        type: 'error',
      })
    )
  }
  // Success
  const showSuccessMessage = (message: string): void => {
    store.dispatch(
      FlashMessageActions.ADD({
        messages: [message],
        type: 'success',
      })
    )
  }

  return {
    showErrorMessage,
    showSuccessMessage,
  }
}
export default useFlashMessage
